import react from "react";
import axios from '../../axios/axiosconf'
import { debeFiltrarPorProfesional } from '../../../utils/userAccessHelpers';
import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import Loading from "../general/Loading";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { formatFecha } from "../../../resources/Helper";
import html2pdf from "html2pdf-fix-jspdf";
import { generarPdfConTextoNativo } from "../../../utils/pdfHelpers";
import { Modal, Button } from "react-bootstrap";

function ModalIncapacidades(props) {

    const queryParams = useLocation().search;
    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(true);
    const [client, setClient] = useState([]);

    const paciente_id = new URLSearchParams(queryParams).get('id');

    const [pacienteId, setPacienteId] = useState(new URLSearchParams(queryParams).get('id'));


    const [contenido, setContenido] = useState('');
    const [fechaHora, setFechaHora] = useState('');

    const [nombreProfesional, setNombreProfesional] = useState('');
    const [profesionalTratante, setProfesionalTratante] = useState(''); // 🆕 Profesional tratante (usuario logueado)
    const [registroMedico, setRegistroMedico] = useState('');
    const [codigoHabilitacion, setCodigoHabilitacion] = useState('');
    const [firmaimg, setFirmaimg] = useState('');
    const [textoPieFirma, setTextoPieFirma] = useState('');

    const [historial, setHistorial] = useState([]);
    const [plantillas, setPlantillas] = useState([]);

    const [errorlist, setErrorlist] = useState({});

    const [tituloResumen, setTituloResumen] = useState();
    const [contenidoResumenIndividual, setContenidoResumenIndividual] = useState();

    const [consolidado, setConsolidado] = useState('');
    const [timelineItemSeleccionadoId, setTimelineItemSeleccionadoId] = useState(null);

    // 🆕 ESTADO PARA ENCABEZADO PERSONALIZADO
    const [encabezadoPersonalizado, setEncabezadoPersonalizado] = useState(null);

    // 🆕 ESTADOS PARA MODALES REACT
    const [showModalConsolidado, setShowModalConsolidado] = useState(false);
    const [showModalResumen, setShowModalResumen] = useState(false);
    const [incapacidadSeleccionada, setIncapacidadSeleccionada] = useState(null);
    const [showModalConfirmacion, setShowModalConfirmacion] = useState(false); // 🆕 Modal post-guardado
    const idIncapacidadGuardadaRef = useRef(null);

    let history = useHistory();
    let userdata = [];
    const logoImg = '/smile/dist/img/logo-2.png';
    const [deshabilitarBotonGuardar, setDeshabilitarBotonGuardar] = useState(false);

    useEffect(() => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
            }
        }

        axios.get('/get-client', config)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                }
            })
            .catch(error => {
                console.log(error);
            });

        axios.get('/perfil', config)
            .then(response => {
                if (response.status === 200) {

                    setNombreProfesional(response.data.name + ' ' + response.data.lastname);
                    setProfesionalTratante(response.data.name + ' ' + response.data.lastname); // 🆕 Profesional tratante
                    setRegistroMedico(response.data.registro_medico);
                    setCodigoHabilitacion(response.data.codigo_habilitacion);
                    setFirmaimg(response.data.firma_blob);
                    setTextoPieFirma(response.data.texto_pie_firma || '');
                }
            })
            .catch(error => {
                console.log(error);
            });

        axios.get('/plantillas-incapacidades', {
            ...config,
            headers: {
                ...config.headers,
                'X-Suppress-403-Modal': '1',
            },
        })
            .then(response => {
                setPlantillas(Array.isArray(response.data) ? response.data : []);
            })
            .catch(error => {
                console.log(error);
                setPlantillas([]);
            })

        // 🆕 Cargar encabezado personalizado del usuario
        axios.get('/encabezado-personalizado?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200 && response.data && response.data.estado === 1) {
                    setEncabezadoPersonalizado(response.data);
                    console.log('Encabezado personalizado cargado:', response.data);
                }
            })
            .catch(error => {
                console.log('No hay encabezado personalizado habilitado:', error);
                setEncabezadoPersonalizado(null);
            });

    }, []);

    const generarEncabezadoHTML = () => {
        if (!encabezadoPersonalizado) {
            return '';
        }

        const limpiarHTML = (html) => {
            if (!html) return '';
            return html
                .replace(/<p>/gi, '<div style="margin: 0; padding: 0; line-height: 1.1;">')
                .replace(/<\/p>/gi, '</div>')
                .replace(/<br\s*\/?>/gi, '<br style="line-height: 1.1;" />');
        };

        return `
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 10px; background-color: #ffffff;">
                <tr>
                    <td style="width: 30%; padding: 2px; font-size: 10px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.izquierda)}
                    </td>
                    
                    <td style="width: 40%; padding: 2px; text-align: center; font-size: 11px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.centro)}
                    </td>
                    
                    <td style="width: 30%; padding: 2px; text-align: right; font-size: 10px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.derecha)}
                    </td>
                </tr>
            </table>
        `;
    };

    const obtenerDatosPacientePdf = () => {
        const p = props.paciente;
        if (!p) {
            return { nombreCompleto: 'Paciente no identificado', documentoCompleto: '—' };
        }
        const nombreCompleto = `${p.primerNombre || ''} ${p.segundoNombre || ''} ${p.primerApellido || ''} ${p.segundoApellido || ''}`.trim() || 'Paciente no identificado';
        const documentoCompleto = p.tipoDocumento && p.numeroDocumento
            ? `${p.tipoDocumento} - ${p.numeroDocumento}`
            : (p.numeroDocumento || '—');
        return { nombreCompleto, documentoCompleto };
    };

    /** Una incapacidad: tabla unificada → título → cuerpo → firma (patrón Otros Documentos / Fórmulas). */
    const construirHtmlCuerpoIncapacidadItem = (incapacidad) => {
        const { nombreCompleto, documentoCompleto } = obtenerDatosPacientePdf();

        const profTrat = incapacidad.profesional_tratante_completo &&
            incapacidad.profesional_tratante_completo !== 'No registrado'
            ? incapacidad.profesional_tratante_completo
            : 'No registrado';

        const celdaEtiqueta = 'background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 28%; border: 1px solid #dee2e6;';
        const celdaValor = 'background-color: #f8f9fa; padding: 8px 12px; border: 1px solid #dee2e6;';

        const tablaUnificada = `
            <div style="margin-bottom: 14px;">
                <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                    <tbody>
                        <tr>
                            <td style="${celdaEtiqueta}">PACIENTE</td>
                            <td style="${celdaValor}">${nombreCompleto}</td>
                        </tr>
                        <tr>
                            <td style="${celdaEtiqueta}">DOCUMENTO</td>
                            <td style="${celdaValor}">${documentoCompleto}</td>
                        </tr>
                        <tr>
                            <td style="${celdaEtiqueta}">FECHA Y HORA</td>
                            <td style="${celdaValor}">${incapacidad.fecha || ''}</td>
                        </tr>
                        <tr>
                            <td style="${celdaEtiqueta}">PROFESIONAL TRATANTE</td>
                            <td style="${celdaValor} font-weight: bold; color: #325e68;">${profTrat}</td>
                        </tr>
                    </tbody>
                </table>
            </div>`;

        const tituloCentrado = `
            <div style="margin: 8px 0 14px; text-align: center; font-weight: bold; font-size: 15px; color: #212529; letter-spacing: 0.02em;">
                INCAPACIDAD MÉDICA
            </div>`;

        const cuerpoHtml = incapacidad.contenido
            ? incapacidad.contenido
            : '<p style="margin:0; color:#6c757d; font-style:italic;">Sin contenido especificado</p>';

        const bloqueIncapacidad = `
            <div style="margin-bottom: 12px;">
                <div style="font-size: 13px; line-height: 1.45;">
                    ${cuerpoHtml}
                </div>
            </div>`;

        const tieneProf = incapacidad.profesional_tratante_completo &&
            incapacidad.profesional_tratante_completo !== 'No registrado';
        let bloqueFirma = '';
        if (tieneProf && incapacidad.profesional && incapacidad.firma_final) {
            const pieFirmaHtml = incapacidad.texto_pie_firma_usuario
                ? `<div style="font-size: 13px; color: #6c757d; line-height: 1.45; white-space: pre-line;">${incapacidad.texto_pie_firma_usuario}</div>`
                : `<div style="font-size: 13px; color: #6c757d; line-height: 1.45;">
                    <strong>${incapacidad.profesional}</strong><br/>
                    RM: ${incapacidad.registro_medico || 'N/A'} | Habilitación: ${incapacidad.codigo_habilitacion || 'N/A'}
                  </div>`;
            bloqueFirma = `
                <div style="height: 1px; background-color: #e9ecef; margin: 24px 0; width: 100%;" role="presentation" aria-hidden="true"></div>
                <div style="margin-top: 0; margin-bottom: 12px; padding-left: 12px; page-break-inside: avoid;">
                    <div style="font-weight: 700; margin-bottom: 8px; text-transform: uppercase; font-size: 13px; color: #212529;">
                        Firma del profesional
                    </div>
                    <div style="display: flex; flex-wrap: wrap; align-items: flex-start; gap: 14px;">
                        <div style="flex: 1; min-width: 160px;">${pieFirmaHtml}</div>
                        <div style="flex-shrink: 0;">
                            <img src="${incapacidad.firma_final}" alt="Firma" style="max-width: 180px; max-height: 90px; display: block;" />
                        </div>
                    </div>
                </div>`;
        }

        return tablaUnificada + tituloCentrado + bloqueIncapacidad + bloqueFirma;
    };

    /** Vista modal “Ver todo”. */
    const construirHtmlConsolidadoIncapacidades = (items) => {
        if (!Array.isArray(items) || items.length === 0) {
            return '';
        }
        const encabezadoPrev = encabezadoPersonalizado && Number(encabezadoPersonalizado.estado) === 1
            ? generarEncabezadoHTML()
            : '';
        const titulo = `
            <div style="margin: 0 0 16px; text-align: center; font-weight: bold; font-size: 15px; color: #212529;">
                INCAPACIDADES
            </div>`;
        let bloques = '';
        items.forEach((item, i) => {
            if (i > 0) {
                bloques += '<div style="height: 1px; background-color: #e9ecef; margin: 24px 0; width: 100%;"></div>';
            }
            bloques += `<div style="page-break-inside: avoid;">${construirHtmlCuerpoIncapacidadItem(item)}</div>`;
        });
        return encabezadoPrev +
            '<div class="consolidado-incapacidades-pdf-paridad" style="font-family: sans-serif; color: #212529;">' +
            titulo +
            bloques +
            '</div>';
    };

    const cargaritems = () => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const esProfesionalIndependiente = debeFiltrarPorProfesional(userdata);

        const config2 = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                id: paciente_id
            }
        }

        // 🆕 PROFESIONAL INDEPENDIENTE - Agregar parámetro de validación si es necesario
        if (esProfesionalIndependiente) {
            config2.params.validar_asignacion = true;
        }

        axios.get('/incapacidades', config2)
            .then(response => {
                console.log('Respuesta incapacidades:', response.data);
                const lista = Array.isArray(response.data) ? response.data : [];
                setHistorial(lista);
                try {
                    setConsolidado(construirHtmlConsolidadoIncapacidades(lista));
                } catch (e) {
                    console.error('Error generando consolidado incapacidades:', e);
                    setConsolidado('');
                }
            })
            .catch(error => {
                console.log('Error cargando incapacidades:', error);
                setHistorial([]);
                setConsolidado('');
            })
    }



    const contenidoHandler = (event, editor) => {
        setContenido(editor.getData());
        setErrorlist((prev) => {
            if (!prev.contenido) return prev;
            const next = { ...prev };
            delete next.contenido;
            return next;
        });
    };




    const formatearFechaHoraParaInput = (fecha = new Date()) => {
        const d = fecha instanceof Date ? fecha : new Date(fecha);
        if (Number.isNaN(d.getTime())) return '';
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        const h = String(d.getHours()).padStart(2, '0');
        const min = String(d.getMinutes()).padStart(2, '0');
        return `${y}-${m}-${day}T${h}:${min}`;
    };

    const establecerFechaHoraActual = () => {
        setFechaHora(formatearFechaHoraParaInput(new Date()));
    };

    const textoPlanoDesdeHtml = (html) => {
        if (!html || typeof html !== 'string') return '';
        const tmp = typeof document !== 'undefined' ? document.createElement('div') : null;
        if (tmp) {
            tmp.innerHTML = html;
            return (tmp.textContent || tmp.innerText || '').replace(/\u00a0/g, ' ');
        }
        return html.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ');
    };

    const contenidoIncapacidadVacio = (html) => {
        return textoPlanoDesdeHtml(html).trim().length === 0;
    };

    const formatearMensajesError = (valor) => {
        if (valor == null) return '';
        if (Array.isArray(valor)) return valor.join(' ');
        return String(valor);
    };

    const handleSubmit = (e) => {

        e.preventDefault();

        if (deshabilitarBotonGuardar || loading) {
            return;
        }

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const erroresCliente = {};

        if (!fechaHora || String(fechaHora).trim() === '') {
            erroresCliente.hora_inicial = ['Indique la fecha y hora de la incapacidad.'];
        }

        if (contenidoIncapacidadVacio(contenido)) {
            erroresCliente.contenido = ['El contenido de la incapacidad es obligatorio.'];
        }

        if (!client || client.client_id == null || client.client_id === '') {
            erroresCliente.general = ['No se cargó la información del cliente. Recargue la página o intente más tarde.'];
        }

        if (Object.keys(erroresCliente).length > 0) {
            setErrorlist(erroresCliente);
            return;
        }

        setErrorlist({});
        setDeshabilitarBotonGuardar(true);
        setLoading(true);

        const esProfesionalIndependiente = debeFiltrarPorProfesional(userdata);

        const axiosConfig = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };

        const data = {
            paciente_id: pacienteId,
            users_id: userdata.user_id,
            profesional: nombreProfesional,
            registro_medico: registroMedico,
            codigo_habilitacion: codigoHabilitacion,
            contenido: contenido,
            hora_inicial: fechaHora
        };

        if (esProfesionalIndependiente) {
            data.validar_asignacion = true;
        }

        axios.post('/incapacidad', data, axiosConfig)
            .then(response => {
                console.log('Incapacidad guardada exitosamente:', response.data);
                const resp = response.data;
                const nuevoId = resp && (resp.id ?? resp.incapacidad_id ?? (resp.data && resp.data.id));
                idIncapacidadGuardadaRef.current = nuevoId != null ? nuevoId : null;

                setLoading(false);
                setContenido('');
                setFechaHora('');
                if (document.getElementById('plantillasIncapacidades')) {
                    document.getElementById('plantillasIncapacidades').value = "";
                }
                cargaritems();
                setErrorlist({});

                setTimeout(() => setShowModalConfirmacion(true), 500);
            })
            .catch(error => {
                setLoading(false);
                setDeshabilitarBotonGuardar(false);
                console.log('Error guardando incapacidad:', error);
                const data = error.response && error.response.data ? error.response.data : null;

                if (data && data.errors && typeof data.errors === 'object') {
                    setErrorlist(data.errors);
                } else {
                    setErrorlist({});
                    const msg = (data && (data.message || data.error)) || error.message || 'No se pudo guardar la incapacidad.';
                    alert(msg);
                }
            })
    }

    const encabezadoPdfNativoDesdeEstado = () => (
        encabezadoPersonalizado && Number(encabezadoPersonalizado.estado) === 1
            ? {
                izquierda: encabezadoPersonalizado.izquierda || '',
                centro: encabezadoPersonalizado.centro || '',
                derecha: encabezadoPersonalizado.derecha || ''
            }
            : null
    );

    const rellenarSeccionesPdfIncapacidadItem = (secciones, incapacidad, { incluirPaciente = true } = {}) => {
        const { nombreCompleto, documentoCompleto } = obtenerDatosPacientePdf();

        const profTrat = incapacidad.profesional_tratante_completo &&
            incapacidad.profesional_tratante_completo !== 'No registrado'
            ? incapacidad.profesional_tratante_completo
            : 'No registrado';

        const filasMeta = [];
        if (incluirPaciente) {
            filasMeta.push({ etiqueta: 'PACIENTE', valor: nombreCompleto });
            filasMeta.push({ etiqueta: 'DOCUMENTO', valor: documentoCompleto });
        }
        filasMeta.push({ etiqueta: 'FECHA Y HORA', valor: String(incapacidad.fecha || '') });
        filasMeta.push({ etiqueta: 'PROFESIONAL TRATANTE', valor: profTrat });

        const gris = [248, 249, 250];
        secciones.push({
            tipo: 'tabla-datos',
            datos: { filas: filasMeta },
            estilos: {
                bodyStyles: { fillColor: gris },
                alternateRowStyles: { fillColor: gris },
                columnStyles: {
                    0: { cellWidth: 52, fontStyle: 'bold', fillColor: gris },
                    1: { cellWidth: 'auto', fillColor: gris },
                },
            },
        });

        secciones.push({
            tipo: 'subtitulo',
            contenido: 'INCAPACIDAD MÉDICA',
            estilos: {
                alineacion: 'center',
                fontSize: 12,
                margenSuperiorMm: 4,
                espacioDespuesMm: 6,
            },
        });

        secciones.push({
            tipo: 'texto',
            contenido: incapacidad.contenido || '<p style="margin:0; color:#6c757d; font-style:italic;">Sin contenido especificado</p>',
            estilos: { margenSuperiorMm: 1 },
        });

        const tieneProf = incapacidad.profesional_tratante_completo &&
            incapacidad.profesional_tratante_completo !== 'No registrado';
        if (tieneProf && incapacidad.profesional && incapacidad.firma_final) {
            const firmaMetadata = incapacidad.texto_pie_firma_usuario
                ? {
                    tipo: 'profesional',
                    textoPieFirma: incapacidad.texto_pie_firma_usuario
                  }
                : {
                    tipo: 'profesional',
                    nombre: incapacidad.profesional || '',
                    registroMedico: incapacidad.registro_medico || 'N/A',
                    codigoHabilitacion: incapacidad.codigo_habilitacion || 'N/A'
                  };
            secciones.push({
                tipo: 'firma',
                imagenBase64: incapacidad.firma_final,
                metadata: firmaMetadata,
                estilos: {
                    estiloEvolucion: true,
                    separadorPrevia: true,
                    margenSuperiorMm: 4,
                },
            });
        }
    };

    /**
     * PDF nativo — ítem único.
     */
    const construirConfigPdfIncapacidadNativo = (incapacidad) => {
        const { nombreCompleto, documentoCompleto } = obtenerDatosPacientePdf();
        const slug = props.docPaciente || props.paciente?.numeroDocumento || 'paciente';

        const config = {
            filename: `incapacidad-${slug}.pdf`,
            paciente: { nombreCompleto, documentoCompleto },
            encabezadoPersonalizado: encabezadoPdfNativoDesdeEstado(),
            omitTablaPacienteInicial: true,
            secciones: []
        };

        rellenarSeccionesPdfIncapacidadItem(config.secciones, incapacidad, { incluirPaciente: true });
        return config;
    };

    /**
     * PDF nativo — historial completo (una página nueva por ítem tras el primero).
     */
    const construirConfigPdfIncapacidadesConsolidadoNativo = () => {
        if (!historial || historial.length === 0) {
            return null;
        }
        const { nombreCompleto, documentoCompleto } = obtenerDatosPacientePdf();
        const slug = props.docPaciente || props.paciente?.numeroDocumento || 'paciente';

        const config = {
            filename: `incapacidades-consolidado-${slug}.pdf`,
            paciente: { nombreCompleto, documentoCompleto },
            encabezadoPersonalizado: encabezadoPdfNativoDesdeEstado(),
            omitTablaPacienteInicial: true,
            secciones: []
        };

        config.secciones.push({
            tipo: 'subtitulo',
            contenido: 'INCAPACIDADES',
            estilos: {
                alineacion: 'center',
                fontSize: 13,
                margenSuperiorMm: 0,
                espacioDespuesMm: 8,
            },
        });

        historial.forEach((item, index) => {
            if (index > 0) {
                config.secciones.push({ tipo: 'salto-pagina' });
            }
            rellenarSeccionesPdfIncapacidadItem(config.secciones, item, { incluirPaciente: true });
        });

        return config;
    };

    /**
     * Vista previa ítem.
     */
    const construirHtmlVistaIncapacidadNativa = (incapacidad) => {
        const encabezadoPrev = encabezadoPersonalizado && Number(encabezadoPersonalizado.estado) === 1
            ? generarEncabezadoHTML()
            : '';

        return encabezadoPrev +
            '<div class="vista-incapacidad-pdf-paridad" style="font-family: sans-serif; color: #212529;">' +
            construirHtmlCuerpoIncapacidadItem(incapacidad) +
            '</div>';
    };

    const verIncapacidad = (incapacidad) => {
        setTituloResumen('Incapacidad Médica - Vista Previa');
        setIncapacidadSeleccionada(incapacidad);
        setTimelineItemSeleccionadoId(incapacidad.id);
        setContenidoResumenIndividual(construirHtmlVistaIncapacidadNativa(incapacidad));
        setShowModalResumen(true);
    };

    /**
     * Limpia el formulario para un registro nuevo.
     * @param {number|string|null} preservarTimelineId - Si se indica, mantiene resaltado ese ítem en el historial.
     */
    const nuevaIncapacidad = (preservarTimelineId = null) => {
        setIncapacidadSeleccionada(null);
        setTimelineItemSeleccionadoId(preservarTimelineId != null ? preservarTimelineId : null);
        setDeshabilitarBotonGuardar(false);
        setFechaHora('');
        setContenido('');

        if (document.getElementById('plantillasIncapacidades')) {
            document.getElementById('plantillasIncapacidades').value = "";
        }
    };

    const descargarPdfIncapacidad = async () => {
        if (!incapacidadSeleccionada) return;

        try {
            const config = construirConfigPdfIncapacidadNativo(incapacidadSeleccionada);
            const pdf = await generarPdfConTextoNativo(config);
            const name = config.filename || 'incapacidad-' + (props.docPaciente || 'paciente') + '.pdf';
            pdf.save(name);
        } catch (err) {
            console.error('PDF nativo incapacidad (descarga):', err);
            alert('No se pudo generar el PDF. Intente de nuevo.');
        }
    };

    const descargarPdfConsolidado = async () => {
        const config = construirConfigPdfIncapacidadesConsolidadoNativo();
        if (!config) {
            alert('No hay incapacidades en el historial para exportar.');
            return;
        }
        try {
            const pdf = await generarPdfConTextoNativo(config);
            pdf.save(config.filename || 'incapacidades-consolidado.pdf');
        } catch (err) {
            console.error('PDF nativo consolidado incapacidades:', err);
            alert('No se pudo generar el PDF consolidado. Intente de nuevo.');
        }
    };

    const imprimirPdfConsolidado = async () => {
        const config = construirConfigPdfIncapacidadesConsolidadoNativo();
        if (!config) {
            alert('No hay incapacidades en el historial para imprimir.');
            return;
        }
        try {
            const pdf = await generarPdfConTextoNativo(config);
            const blob = pdf.output('blob');
            const url = URL.createObjectURL(blob);
            const printWindow = window.open(url, '_blank');
            if (printWindow) {
                printWindow.onload = function () {
                    setTimeout(() => printWindow.print(), 500);
                };
            } else {
                window.open(url, '_blank');
            }
        } catch (err) {
            console.error('Imprimir PDF nativo consolidado:', err);
            alert('No se pudo generar el PDF para imprimir.');
        }
    };

    // Imprimir incapacidad (PDF nativo; foliación incluida en generarPdfConTextoNativo)
    const imprimirIncapacidad = async () => {
        if (!incapacidadSeleccionada) {
            alert('No hay incapacidad seleccionada para imprimir');
            return;
        }

        try {
            const config = construirConfigPdfIncapacidadNativo(incapacidadSeleccionada);
            const pdf = await generarPdfConTextoNativo(config);
            const blob = pdf.output('blob');
            const url = URL.createObjectURL(blob);
            const printWindow = window.open(url, '_blank');

            if (printWindow) {
                printWindow.onload = function () {
                    setTimeout(() => printWindow.print(), 500);
                };
            } else {
                const iframe = document.createElement('iframe');
                iframe.style.position = 'fixed';
                iframe.style.right = '0';
                iframe.style.bottom = '0';
                iframe.style.width = '0';
                iframe.style.height = '0';
                iframe.style.border = 'none';
                iframe.src = url;
                document.body.appendChild(iframe);

                iframe.onload = function () {
                    setTimeout(() => {
                        try {
                            iframe.contentWindow.focus();
                            iframe.contentWindow.print();
                            setTimeout(() => {
                                document.body.removeChild(iframe);
                                URL.revokeObjectURL(url);
                            }, 1000);
                        } catch (e) {
                            console.error('Error al imprimir:', e);
                            alert('No se pudo abrir el diálogo de impresión. Descargue el PDF e imprímalo desde su visor.');
                            document.body.removeChild(iframe);
                            URL.revokeObjectURL(url);
                        }
                    }, 500);
                };
            }
        } catch (err) {
            console.error('PDF nativo incapacidad (imprimir):', err);
            alert('No se pudo generar el PDF para imprimir.');
        }
    };

    const handleCerrarModalConfirmacion = () => {
        setShowModalConfirmacion(false);
        let idSel = idIncapacidadGuardadaRef.current;
        idIncapacidadGuardadaRef.current = null;
        if (idSel == null && historial && historial.length > 0) {
            idSel = historial[0].id;
        }
        nuevaIncapacidad(idSel);
        // No guardarCambios(msg): evita toast duplicado; el modal ya informa el éxito y cargaritems() ya corrió al guardar.
    };

    useEffect(() => {
        if (!props.cargarHistorial) return;
        cargaritems();
    }, [props.cargarHistorial]);


    const descargarPdf = () => {
        var opt = {
            margin: 10,
            filename: `incapacidades.pdf`,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: {
                scale: 2,
                useCORS: true,
                allowTaint: true,
                letterRendering: true,
                scrollY: 0
            },
            jsPDF: { unit: 'mm', format: 'letter', orientation: 'portrait' },
            pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
        };

        let anamnesis = props.anamnesis();
        let incapacidadesCompleta = "<img src='" + logoImg + "' class='app-logo-pdf' /><h1 class='ttl-pdf'>INCAPACIDADES</h1>" + anamnesis + "<div class='salto-pagina-pdf'></div>" + consolidado;

        html2pdf(incapacidadesCompleta, opt);
    };


    if (loggedIn) {
        return (

            <>
                <section className="content">
                    <div className="container-fluid">

                        <div className="row">
                            <div className="col-md-9">

                                <div className="mb-3 pb-2 border-bottom">
                                    <small className="text-muted">
                                        Seleccione una fecha en el historial para abrir la vista previa e imprimir o descargar ese registro.
                                    </small>
                                </div>

                                {errorlist.general && (
                                    <div className="alert alert-warning py-2 px-3 mb-3" role="alert">
                                        {formatearMensajesError(errorlist.general)}
                                    </div>
                                )}

                                <form id="role-form" onSubmit={handleSubmit} autoComplete="off">

                                    <div id="historiageneral">
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-md-5">
                                                        <div className="form-group">
                                                            <label><i className="fas fa-user-md"></i> Profesional Tratante</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={profesionalTratante}
                                                                readOnly
                                                                style={{ backgroundColor: '#f8f9fa', fontWeight: 'bold' }}
                                                            />
                                                            <small className="text-muted">Usuario que realiza la incapacidad</small>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-7">
                                                        <div className="form-group">
                                                            <label>Fecha y Hora <span className="text-danger">*</span></label>
                                                            <div className="input-group">
                                                                <input
                                                                    type="datetime-local"
                                                                    className={'form-control' + (errorlist.hora_inicial ? ' is-invalid' : '')}
                                                                    required
                                                                    value={fechaHora}
                                                                    onChange={(e) => {
                                                                        setFechaHora(e.target.value);
                                                                        setErrorlist((prev) => {
                                                                            if (!prev.hora_inicial) return prev;
                                                                            const next = { ...prev };
                                                                            delete next.hora_inicial;
                                                                            return next;
                                                                        });
                                                                    }}
                                                                />
                                                                <div className="input-group-append">
                                                                    <button type="button" className="btn btn-sm btn-dark" onClick={establecerFechaHoraActual}>
                                                                        <i className="fas fa-clock"></i> Fecha y Hora Actual
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            {errorlist.hora_inicial && (
                                                                <div className="invalid-feedback d-block">
                                                                    {formatearMensajesError(errorlist.hora_inicial)}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="form-group">
                                                    <label>Seleccione la incapacidad o digite su contenido <span className="text-danger">*</span></label>
                                                    <select
                                                        name="plantillasIncapacidades"
                                                        className="form-control"
                                                        id="plantillasIncapacidades"
                                                        onChange={(e) => setContenido(e.target.value)}
                                                    >
                                                        <option></option>
                                                        {(Array.isArray(plantillas) ? plantillas : []).map((plantilla, index) =>
                                                            <option key={index} value={plantilla.contenido}>{plantilla.titulo}</option>
                                                        )}
                                                    </select>
                                                </div>

                                                <div className="form-group" style={{ marginBottom: 0 }}>
                                                    <label>Contenido</label>
                                                    <CKEditor editor={ClassicEditor} onChange={contenidoHandler} data={contenido} />
                                                    {errorlist.contenido && (
                                                        <div className="invalid-feedback d-block">
                                                            {formatearMensajesError(errorlist.contenido)}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card">
                                        <div id="profesional-atiende">
                                            <div className="card-body" style={{ padding: '0.7rem' }}>
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="nombreProfesional">Profesional que atiende</label>
                                                            <br></br>
                                                            {nombreProfesional}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="nombreProfesional">Registro médico</label>
                                                            <br></br>
                                                            {registroMedico}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="clasificacion_riesgo">Código de habilitación</label>
                                                            <br></br>
                                                            {codigoHabilitacion}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    {firmaimg && (
                                                        <div className="col-md-4">
                                                            <div className="form-group" style={{ marginBottom: '0.4rem' }}>
                                                                <label htmlFor="nombreProfesional">Firma</label>
                                                                <br></br>
                                                                <img src={firmaimg} className="firma-profesional-hc" alt="" />
                                                            </div>
                                                        </div>
                                                    )}
                                                    <div className={firmaimg ? 'col-md-8' : 'col-md-12'}>
                                                        <div className="form-group" style={{ marginBottom: '0.4rem' }}>
                                                            <label>Pie de Firma</label>
                                                            <br></br>
                                                            {textoPieFirma ? (
                                                                <div style={{ whiteSpace: 'pre-line', fontSize: '0.75rem', color: '#495057', lineHeight: '1.6' }}>
                                                                    {textoPieFirma}
                                                                </div>
                                                            ) : (
                                                                <div style={{ fontSize: '0.75rem', color: '#6c757d' }}>
                                                                    {nombreProfesional}<br/>
                                                                    <small>RM: {registroMedico || 'N/A'} | Hab: {codigoHabilitacion || 'N/A'}</small>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <button type="submit" className="btn btn-secondary" disabled={deshabilitarBotonGuardar}>
                                                Guardar&nbsp;
                                                {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null}
                                            </button>
                                            &nbsp;
                                            <button type="button" className="btn btn-outline-secondary" onClick={(e) => { e.preventDefault(); props.cerrarModal(); }}>Cerrar</button>
                                        </div>
                                    </div>


                                </form>


                            </div>
                            <div className="col-md-3">
                                <div className="timeline-evolucion">

                                    <b className="titulo-historial">Historial de Incapacidades</b>

                                    {
                                        (Array.isArray(historial) ? historial : []).map((item) =>

                                            <div
                                                className="timeline-item-container"
                                                key={item.id}
                                                onClick={() => verIncapacidad(item)}
                                                style={{
                                                    cursor: 'pointer',
                                                    ...(timelineItemSeleccionadoId != null && String(timelineItemSeleccionadoId) === String(item.id)
                                                        ? { backgroundColor: 'rgba(23, 162, 184, 0.12)', borderRadius: '8px', padding: '4px 6px' }
                                                        : {})
                                                }}
                                            >
                                                <div className="timeline-punto-container"><div className="timeline-punto" style={timelineItemSeleccionadoId != null && String(timelineItemSeleccionadoId) === String(item.id) ? { backgroundColor: '#17a2b8', borderColor: '#17a2b8' } : undefined}></div></div>
                                                <div className="timeline-meta">{formatFecha(new Date(item.fecha))}</div>
                                            </div>
                                        )
                                    }

                                </div>

                                <button type="button" className="btn btn-sm btn-dark btn-resumen-historico" onClick={() => setShowModalConsolidado(true)}>Ver Todo</button>

                            </div>
                        </div>
                    </div>
                </section>

                <Modal show={showModalResumen} onHide={() => setShowModalResumen(false)} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title className="text-secondary" style={{ fontSize: '1.1rem' }}>{tituloResumen}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ paddingTop: '0.5rem' }}>
                        <div className="resumen-historico" dangerouslySetInnerHTML={{ __html: contenidoResumenIndividual }} />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="dark" size="sm" onClick={imprimirIncapacidad}>
                            <i className="fas fa-print mr-1"></i> Imprimir
                        </Button>
                        <Button variant="dark" size="sm" onClick={descargarPdfIncapacidad}>
                            <i className="fas fa-file-pdf mr-1"></i> Descargar PDF
                        </Button>
                        <Button variant="secondary" size="sm" onClick={() => setShowModalResumen(false)}>
                            <i className="fas fa-times mr-1"></i> Cerrar
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={showModalConsolidado} onHide={() => setShowModalConsolidado(false)} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title className="text-secondary" style={{ fontSize: '1.1rem' }}>Resumen incapacidades</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ paddingTop: '0.5rem' }}>
                        <div className="resumen-historico" dangerouslySetInnerHTML={{ __html: consolidado }} />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="dark" size="sm" onClick={imprimirPdfConsolidado}>
                            <i className="fas fa-print mr-1"></i> Imprimir
                        </Button>
                        <Button variant="dark" size="sm" onClick={descargarPdfConsolidado}>
                            <i className="fas fa-file-pdf mr-1"></i> Descargar PDF
                        </Button>
                        <Button variant="secondary" size="sm" onClick={() => setShowModalConsolidado(false)}>
                            <i className="fas fa-times mr-1"></i> Cerrar
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={showModalConfirmacion} onHide={handleCerrarModalConfirmacion} centered>
                    <Modal.Header closeButton>
                        <Modal.Title className="text-secondary" style={{ fontSize: '1.1rem' }}>
                            <i className="fas fa-file-medical mr-1"></i> Incapacidad Guardada
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p className="mb-0" style={{ fontSize: '16px' }}>
                            La incapacidad ha sido Guardada Exitosamente. Puede abrirla desde el Historial para Vista Previa o PDF.
                        </p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" size="sm" onClick={handleCerrarModalConfirmacion}>
                            <i className="fas fa-times mr-1"></i> Cerrar
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>

        );
    }

    return (
        <Loading />
    );
}
export default ModalIncapacidades;